import URI from 'urijs';
const baseURL = 'https://api.mapbox.com';
export const buildMapboxURI = function (path) {
  let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return URI(`${baseURL}${path}`).search({
    ...params,
    access_token: window.processRuntime.env?.MAPBOX_ACCESS_TOKEN
  });
};